import r from "../managers/braze-instance.js";
import nr from "./feature-flags-provider-factory.js";
export function getAllFeatureFlags() {
  if (!r.rr()) return;
  const t = [],
    e = r.v();
  if (e && !e.ke()) return t;
  const n = nr.m().Me();
  for (const r in n) t.push(n[r]);
  return t;
}
